import weixinJSBridgeReady from './weixinJSBridgeReady'

export default function () {
  weixinJSBridgeReady(function () {
    WeixinJSBridge.invoke("hideOptionMenu", {}, function () { })
  })
}
